import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

// What the agent writes is markdown, and it is not ours: it can quote anything it read in the
// PLM, which is text other people wrote. So it is rendered, then sanitised, and links get a
// target only the sanitiser allows through.
const markdown = new MarkdownIt({ linkify: true, breaks: true, html: false });

/**
 * The PLM path a link points at, or null if it points anywhere else.
 *
 * One leading slash, and not two: `//host` is a URL wearing a path's clothes. It resolves
 * off-origin, so treating it as in-app would hand the router something it cannot push.
 */
export function plmPath(href: string): string | null {
  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  const path = origin && href.startsWith(origin) ? href.slice(origin.length) : href;
  return /^\/([^/]|$)/.test(path) ? path : null;
}

// Links open away from the PLM unless they point back into it. The router picks those up on
// click (see agent-markdown.vue); everything else must not replace the app.
markdown.renderer.rules.link_open = (tokens, index, options, _env, self) => {
  const href = String(tokens[index].attrGet('href') ?? '');
  if (plmPath(href) === null) {
    tokens[index].attrSet('target', '_blank');
    tokens[index].attrSet('rel', 'noopener noreferrer');
  }
  return self.renderToken(tokens, index, options);
};

export function renderAgentMarkdown(source: string): string {
  return DOMPurify.sanitize(markdown.render(source), { ADD_ATTR: ['target'] });
}
